import * as React from "react";
import PrivacyPolicyView from "../presentation/privacy-policy";
export default class PrivacyPolicy extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement(PrivacyPolicyView, null));
    }
}
;
//# sourceMappingURL=privacy-policy.js.map